<mat-form-field appearance="outline" class="w-full">
  <mat-label>Type</mat-label>
  <mat-select [formControl]="formCtrl">
    <mat-option *ngFor="let columnType of state.columnTypes; trackBy: trackByName" [value]="columnType.columnType">
      <y42-column-type-icon *ngIf="columnType.columnType" [type]="columnType.columnType"></y42-column-type-icon>
      {{ columnType.name }}
    </mat-option>
    <mat-select-trigger>
      <y42-column-type-icon *ngIf="formCtrl.value" [type]="formCtrl.value"></y42-column-type-icon>
      {{ state.selectedColumnType }}
    </mat-select-trigger>
  </mat-select>
</mat-form-field>
